import { Route } from "react-router";

import { IRoute } from "@interfaces";
import { AuthLayout } from "@layouts";
import { enumSubdomain } from "@configs";
import { selectAuth, selectApp, updateDoamin } from "@redux";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import styled from "styled-components";

export const ComponentAppRoute = (props: IRoute) => {
  const { path, exact } = props;
  const { hostname } = window.location;
  const token = useSelector(selectAuth)?.auth?.token;
  const { domain } = useSelector(selectApp);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    updateSubdomain();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [hostname]);

  const subdomain = hostname.split(".")[0] as enumSubdomain;

  const updateSubdomain = async () => {
    if (domain !== subdomain) {
      await dispatch(updateDoamin(subdomain));
    }
  };

  const Component = props.component;
  const Layout = props.layout || AuthLayout;

  if (token === undefined && loading) {
    return (
      <StyledDiv>
        <Spin spinning={loading} tip="Loading..." />
      </StyledDiv>
    );
  }

  return (
    <Route
      path={path}
      exact={exact}
      render={() => (
        <Layout>
          <Component />
        </Layout>
      )}
    />
  );
};

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
